import {
  FRONT_DOOR_HELP_CLASS,
  FRONT_DOOR_LINK_CLASS,
  FRONT_DOOR_PANEL_TITLE_CLASS,
  FRONT_DOOR_PRIMARY_BUTTON_CLASS,
} from "@/app/(front-door)/_components/styles";
import { MarbleLink as Link } from "@/app/_components/ui/marble-link";
import {
  FRONT_DOOR_CAREERS_URL,
  FRONT_DOOR_PROVIDERS_EMAIL,
} from "@/lib/modules/auth/front-door";
import { cn } from "@/lib/utils";
import { ArrowRight, ExternalLink } from "lucide-react";

/** Families don't sign up; their accounts come from a referral. */
export const ReferPanel = ({
  isSelf,
  referHref,
  onReferSelf,
}: {
  isSelf: boolean;
  /** `getFrontDoorReferHref`, so a link's own params reach the referral. */
  referHref: string;
  /** On `/portal/login` with the pills hidden, a way to the Patient copy. */
  onReferSelf?: () => void;
}) => (
  <div>
    <h2 className={FRONT_DOOR_PANEL_TITLE_CLASS}>
      {isSelf
        ? "Interested in therapy for yourself?"
        : "Interested in therapy for your family?"}
    </h2>
    <p className={`mb-[22px] mt-2 text-[14.5px] ${FRONT_DOOR_HELP_CLASS}`}>
      {isSelf
        ? "Start a referral for your own care. It takes just a couple of minutes."
        : "Start a referral for your child or another family member. It takes just a couple of minutes."}
    </p>
    <Link
      href={referHref}
      className={cn(
        "inline-flex items-center justify-center",
        FRONT_DOOR_PRIMARY_BUTTON_CLASS,
      )}
    >
      Start a referral
      <ArrowRight className="h-4 w-4" aria-hidden />
    </Link>
    <p className={`mt-3.5 text-center ${FRONT_DOOR_HELP_CLASS}`}>
      {
        "No account or password needed — we'll set up your family's account from the referral."
      }
    </p>
    {onReferSelf && (
      <p className={`mt-2 text-center ${FRONT_DOOR_HELP_CLASS}`}>
        {"Referring yourself? "}
        <button
          type="button"
          onClick={onReferSelf}
          className={FRONT_DOOR_LINK_CLASS}
        >
          Start a self-referral
        </button>
      </p>
    )}
  </div>
);

/** Therapist accounts are by invitation only. */
export const TherapistInvitePanel = () => (
  <div>
    <h2 className={FRONT_DOOR_PANEL_TITLE_CLASS}>
      Joining Marble as a therapist?
    </h2>
    <p className="mt-3 text-[15px] leading-relaxed text-[#4a4a4a]">
      {
        "Marble therapist accounts are by invitation only. If you've been invited, use the link in your invite email to set up your account."
      }
    </p>
    <a
      href={FRONT_DOOR_CAREERS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "mt-[22px] inline-flex items-center justify-center",
        FRONT_DOOR_PRIMARY_BUTTON_CLASS,
      )}
    >
      See open roles
      <ExternalLink className="h-[15px] w-[15px]" aria-hidden />
    </a>
    <p className={`mt-4 text-center ${FRONT_DOOR_HELP_CLASS}`}>
      {"Can't find your invite? Email "}
      <a
        href={`mailto:${FRONT_DOOR_PROVIDERS_EMAIL}`}
        className={FRONT_DOOR_LINK_CLASS}
      >
        {FRONT_DOOR_PROVIDERS_EMAIL}
      </a>
    </p>
  </div>
);
